export default "__VITE_ASSET__Dg81hw5B__"